var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("h1", [_vm._v("AdminServerTm")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n        Как долго должен выполняться запрос на сервере\n        "
      ),
      _c("br"),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _setup.sec,
            expression: "sec",
          },
        ],
        attrs: { type: "number" },
        domProps: { value: _setup.sec },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _setup.sec = $event.target.value
          },
        },
      }),
      _vm._v(" - количество секунд\n        "),
      _c("br"),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _setup.isPost,
            expression: "isPost",
          },
        ],
        attrs: { type: "checkbox" },
        domProps: {
          checked: Array.isArray(_setup.isPost)
            ? _vm._i(_setup.isPost, null) > -1
            : _setup.isPost,
        },
        on: {
          change: function ($event) {
            var $$a = _setup.isPost,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_setup.isPost = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_setup.isPost = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _setup.isPost = $$c
            }
          },
        },
      }),
      _vm._v(" - выполнить post\n        "),
      _c("br"),
      _c("button", { on: { click: _setup.doReq } }, [
        _vm._v("выполнить sleep(" + _vm._s(_setup.sec) + ")"),
      ]),
    ]),
    _setup.req.wait ? _c("div", [_vm._v("ждите....")]) : _vm._e(),
    _vm._v(" "),
    !_setup.req.wait && (_setup.req.resolve || _setup.req.reject)
      ? _c("div", [
          _c("div", [
            _vm._v(
              "ожидание фактически: " +
                _vm._s(
                  Math.round((_setup.req.finish - _setup.req.start) / 1000)
                ) +
                " секунд"
            ),
          ]),
          _vm._v(" "),
          _c("div", [_vm._v("ожидание по плану: " + _vm._s(_setup.sec))]),
          _vm._v(" "),
          _setup.req.resolve
            ? _c("div", [
                _c("b", [
                  _vm._v(
                    "выполнен sleep(" + _vm._s(_setup.req.resolve.sec) + ")"
                  ),
                ]),
              ])
            : _c("div", [
                _c("span", { staticStyle: { color: "#aa0000" } }, [
                  _vm._v("ОШИБКА: " + _vm._s(_setup.req.reject)),
                ]),
              ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("p"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }